<template>
  <div v-if="fbIsInit">
    <CreateUserTemplate
      :first-name="USER.first_name"
      :email="USER.email"
      :loading="loading"
      :disable-email-input="true"
      @update-first-name="SET_USER({ ...USER, first_name: $event })"
      @request-signup="finalizeSingup"
    >
      <template v-slot:top>
        <div class="title">
          {{ $t("band.signup.init.facebookUser.title.main") }}
        </div>
        <div class="subtitle">
          {{ $t("band.signup.init.facebookUser.title.sub") }}
        </div>
      </template>
    </CreateUserTemplate>
  </div>
</template>
<script>
import { mapActions } from "vuex"

import CreateUserTemplate from "~/components/band/signup/init/createUser/template"

import FacebookMixin from "~/mixins/third_party/manipulation/facebook"
import EventMixin from "~/mixins/events"
import SharedDataMixin from "./createUser/sharedData.js"

import createUserTracking from "~/helpers/signup/createUserTracking.js"

export default {
  components: {
    CreateUserTemplate,
  },
  mixins: [FacebookMixin, SharedDataMixin, EventMixin],
  data() {
    return {
      loading: true,
    }
  },
  async created() {
    this.loading = true
    if (this.fbIsInit) this.initFbModule()
    else this.fbLoad(this.initFbModule.bind(this), this.handleFbError)
  },
  methods: {
    createUserTracking,
    initFbModule() {
      this.facebookRoutine()
        .then((resp) => {
          console.log({ resp })
          this.loading = false
        })
        .catch(this.handleFbError)
    },
    handleFbError(err) {
      this.$sentry.captureException(err)
      this.CREATE_SNACKBAR({
        props: {
          text: err.message,
          icon: "fas fa-bug",
        },
      })
      this.$emit("cancel-facebook")
    },
    trackFinalizeEvent() {
      this.createUserTracking()
      this.trackEvent({
        category: "Band Signup",
        action: "Create User",
        label: "fb",
      })
    },
    finalizeSingup() {
      this.loading = true
      this.checkForAlreadyExistingUsr()
        .then(() => {
          this.$axios("/facebook/signup/", {
            id: this.fbData.authResponse.userID,
            access_token: {
              short_lived_token: this.fbData.authResponse.accessToken,
            },
            user: {
              email: this.USER.email,
              first_name: this.USER.first_name,
              last_name: this.USER.last_name,
              lang: this.LANG,
            },
          })
            .then((resp) => {
              this.trackFinalizeEvent()
              this.SET_USER(resp)
              this.$emit("signup-success")
            })
            .catch((err) => {
              this.$sentry.captureException(err)
            })
        })
        .catch(() => {
          console.info("User already here, swapping to login prompt")
        })
    },
    async facebookRoutine() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.fbAuth()
          .then(() => {
            if (this.fbIsLoggedIn) {
              this.fbFetchData().then((resp) => {
                this.SET_USER({
                  email: resp.email,
                  first_name:
                    resp.short_name || resp.name || resp.last_name || "",
                })
                resolve(resp)
              })
            } else reject(new Error("Facebook routine failed"))
          })
          .catch((err) => {
            console.log({ err })
            reject(err)
          })
      })
    },
    ...mapActions({
      CREATE_SNACKBAR: "snackbar/CREATE",
    }),
  },
}
</script>
<style scoped>
.title,
.subtitle {
  text-align: center;
}

.title {
  font-family: EuclidFlex;
  font-size: var(--font-size-title-micro);
  font-weight: 600;
  margin-bottom: 16px;
}

.subtitle {
  font-size: var(--font-size);
  color: var(--color-dark-grey);
  margin-bottom: 32px;
}
</style>
